export default {
  PassengerAccommodationsFormFields__DISCLAIMER:
    "Need a specific seat to accommodate a disability? After completing your reservation, we strongly recommend you call us at 1-800-I-FLY-SWA (1-800-435-9792) or contact us through our",
  PassengerAccommodationsFormFields__HELP_CENTER: "Help Center",
  PassengerAccommodationsFormFields__NOTE: "Note:",
};
